var getRemoteAssetUrl = function getRemoteAssetUrl(hash, cdnUrl) {
  return {
    url: "".concat(cdnUrl).concat(hash, ".svg"),
    preloaded: false
  };
};
var getLocalSymbolAssetUrl = function getLocalSymbolAssetUrl(hash, localAssets) {
  var assetContent = localAssets[hash];
  if (assetContent === undefined) {
    return undefined;
  }
  var svgContent = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\">".concat(assetContent, "<use href=\"#").concat(hash, "\" /></svg>");
  var dataUrl = "data:image/svg+xml;base64,".concat(btoa(svgContent));
  return {
    url: dataUrl,
    preloaded: true
  };
};

export { getLocalSymbolAssetUrl, getRemoteAssetUrl };
//# sourceMappingURL=getAssetUrl.js.map
